export const yo = {
  "nav.check_booking": "Ṣayẹwo Ìpamọ́",
  "nav.admin": "Alákòóso",
  "nav.book_now": "Pamọ́ Báyìí",
  "nav.driver": "Awakọ̀",
  "hero.badge": "Gbígbé Fún Àwọn Akẹ́kọ̀ọ́ Visa J1",
  "hero.title": "Gbígbé Rọrùn",
  "hero.subtitle": "Gbígbé Tó Ṣe É Gbẹ́kẹ̀lé Láti Àwọn Pápá Ọkọ̀ Òfuurufú Chicago Sí Wisconsin",
  "hero.description": "Gbígbé tó ní ààbò, tó ṣe é gbẹ́kẹ̀lé, àti tó wọ́n fún àwọn akẹ́kọ̀ọ́ visa J1. Pamọ́ gbígbé rẹ láti pápá ọkọ̀ òfuurufú tàbí ìrìn àjò ìpadà lónìí!",
  "hero.book_trip": "Pamọ́ Ìrìn Àjò Rẹ",
  "hero.check_status": "Ṣayẹwo Ipò Ìpamọ́",
  "pricing.title": "Iye Owó Gbígbé",
  "pricing.subtitle": "Gbogbo iye owó ní USD",
  "pricing.ohare_mke": "Gbígbé (O'Hare / Milwaukee)",
  "pricing.midway": "Gbígbé (Midway)",
  "pricing.madison": "Madison sí Wisconsin Dells",
  "pricing.return": "Àdínkù Fún Ìpadà",
  "pricing.shared": "Ìrìn Àjò Àpapọ̀",
  "pricing.private": "Ìrìn Àjò Àdáni",
  "pricing.per_person": "fún ẹnìkọ̀ọ̀kan",
  "pricing.after_deposit": "lẹ́yìn ìdógó $20",
  "pricing.without_deposit": "láìsí ìdógó",
  "pricing.flat_rate": "iye owó pàtó",
  "pricing.per_suitcase": "Fún àpò kọ̀ọ̀kan",
  "pricing.carry_on": "Àpò ọwọ́",
  "pricing.free": "ÒFẸ́",
  "pricing.with_shipping": "Padà + fi ránṣẹ́ pẹ̀lú wa",
  "pricing.special_deal": "Àdéhùn Pàtàkì!",
  "pricing.midway_contact": "Kàn sí wa fún iye owó Midway (MDW)",
  "pricing.waterpark_note": "Iye owó lè yàtọ̀ fún Three Bears Water Park tàbí àwọn ibi tó yàtọ̀.",
  "pricing.contact_us": "Kàn sí wa",
  "pricing.guidelines_title": "Bí Iye Owó Wa Ṣe Ń Ṣiṣẹ́",
  "pricing.guidelines_deposit": "Ìdógó $20 fún ẹnìkọ̀ọ̀kan ń dáàbò bo ibi rẹ. Ìyókù owó ní ọjọ́ ìrìn àjò.",
  "pricing.guidelines_shared": "Àwọn arìnrìn àjò 2 tàbí ju bẹ́ẹ̀ lọ tí wọ́n ń rìn ní ọjọ́ kan náà sí pápá ọkọ̀ òfuurufú kan náà máa gba iye owó àpapọ̀.",
  "pricing.guidelines_solo": "Àwọn arìnrìn àjò ọ̀kan ṣoṣo (arìnrìn àjò nìkan ní ọjọ́ yẹn) lè san iye owó tó ga díẹ̀.",
  "pricing.guidelines_suitcase": "Àpò 1 wà nínú ọ̀fẹ́ fún ìrìn àjò ìpadà. Àpò afikún kọ̀ọ̀kan jẹ́ $5.",
  "pricing.guidelines_payment": "A gbà ìsanwó Káàdì, Owó, àti Zelle.",
  "requirements.title": "Àwọn Ohun Tó Nílò Fún Ìpamọ́",
  "requirements.pickup": "A pèsè gbígbé lẹ́ẹ̀mejì nínú wákàtí 24 àyàfi tí a bá sọ bí kò ṣe rí. Gbero sáájú!",
  "requirements.deposit": "Ìdógó $20 USD tí kò lè padà nílò kí a tó fi ọ sí àtòjọ.",
  "requirements.seamless": "Dáàbò bo ibi rẹ nípa ṣíṣe ìdógó rẹ sáájú.",
  "requirements.final_payment": "Ìyókù owó ní kí a tó wọ inú ọkọ̀.",
  "special.title": "Ibi Tí A Ń Lọ Kò Sí Lórí Àtòjọ?",
  "special.description": "A pèsè ìrìn àjò àìfíṣe-déédéé sí àwọn ibi tó yàtọ̀ sí ipa ọ̀nà wa déédéé. Kàn sí wa fún iye owó pàtó!",
  "special.call": "Pe",
  "special.whatsapp": "WhatsApp Wa",
  "features.title": "Kí Nìdí Tí O Fi Yan Gbígbé Rọrùn?",
  "features.subtitle": "Àwọn ẹgbẹẹgbẹ̀rún àwọn akẹ́kọ̀ọ́ J1 gbẹ́kẹ̀lé rẹ̀ ní ìgbà ẹ̀ẹ̀rùn kọ̀ọ̀kan",
  "features.easy_booking": "Ìpamọ́ Rọrùn",
  "features.easy_booking_desc": "Ìdógó $20 USD nìkan ní a nílò. San nípasẹ̀ gbígbé owó ilé ìfowópamọ́, káàdì, PayPal, tàbí Zelle.",
  "features.safe": "Ààbò àti Ìgbẹ́kẹ̀lé",
  "features.safe_desc": "Àwọn awakọ̀ alámọ̀dà, àwọn ọkọ̀ tó rọrùn, àti ìrànlọ́wọ́ 24/7 fún àwọn akẹ́kọ̀ọ́ J1.",
  "features.flexible": "Àtòjọ Tó Rọ̀",
  "features.flexible_desc": "Pamọ́ ìrìn àjò ìdé àti ìpadà. Àpò àkọ́kọ́ lọ́fẹ̀ẹ́ ní ìpadà!",
  "video.badge": "Wo Wa Ní Iṣẹ́",
  "video.title": "Ìrìn Àjò Rẹ Bẹ̀rẹ̀ Níbí",
  "video.subtitle": "Wo àwọn akẹ́kọ̀ọ́ J1 tí wọ́n bẹ̀rẹ̀ ìrìn àjò wọn",
  "video.book_now": "Pamọ́ Gbígbé Rẹ Báyìí",
  "booking.title": "Pamọ́ Ìrìn Àjò Rẹ",
  "booking.step": "Ìgbésẹ̀",
  "booking.of": "nínú",
  "booking.trip_type": "Irú Ìrìn Àjò",
  "booking.arrival": "Ìdé (Gbígbé Pápá Ọkọ̀ Òfuurufú)",
  "booking.return": "Ìpadà (Sí Pápá Ọkọ̀ Òfuurufú)",
  "booking.ride_type": "Irú Gbígbé",
  "booking.shared_ride": "Gbígbé Àpapọ̀",
  "booking.shared_desc": "Pín pẹ̀lú àwọn arìnrìn àjò mìíràn lórí ipa ọ̀nà kan náà",
  "booking.private_ride": "Gbígbé Àdáni",
  "booking.private_desc": "Ọkọ̀ pàtó fún ọ nìkan",
  "booking.pickup_location": "Pápá Ọkọ̀ Òfuurufú Gbígbé",
  "booking.select_airport": "Yan Pápá Ọkọ̀ Òfuurufú",
  "booking.travel_date": "Ọjọ́ Ìrìn Àjò",
  "booking.travel_time": "Àkókò Ìdé Tí A Ń Retí",
  "booking.departure_time": "Àkókò Ìlọ",
  "booking.flight_number": "Nọ́mbà Ọkọ̀ Òfuurufú",
  "booking.airline": "Ilé Iṣẹ́ Ọkọ̀ Òfuurufú",
  "booking.terminal": "Tẹ́mínálì Ìdé",
  "booking.full_name": "Orúkọ Kíkún",
  "booking.whatsapp": "Nọ́mbà WhatsApp",
  "booking.email": "Àdírẹ́sì Ímeèlì",
  "booking.housing": "Ilé Ìgbé",
  "booking.select_housing": "Yan Ilé",
  "booking.custom_address": "Tẹ Àdírẹ́sì Pàtó Sí",
  "booking.num_passengers": "Iye Àwọn Arìnrìn Àjò",
  "booking.suitcases": "Àpapọ̀ Àwọn Àpò",
  "booking.shipping": "Ṣé O Ń Lo T&M Courier?",
  "booking.payment": "Ọ̀nà Ìsanwó",
  "booking.referral": "Kóòdù Ìtọ́kasí",
  "booking.next": "Tó Kàn",
  "booking.previous": "Ti Tẹ́lẹ̀",
  "booking.submit": "Parí Ìpamọ́",
  "booking.processing": "Ń Ṣiṣẹ́...",
  "booking.start_over": "Bẹ̀rẹ̀ Lẹ́ẹ̀kansi",
  "booking.first_time": "Ìrìn Àjò Àkọ́kọ́",
  "booking.returning": "Oníbàárà Tí Ó Ń Padà",
  "booking.confirmation_number": "Nọ́mbà Ìjẹ́rìísí",
  "pricing_summary.title": "Àkópọ̀ Iye Owó",
  "pricing_summary.trip_price": "Iye Owó Ìrìn Àjò",
  "pricing_summary.luggage_fee": "Owó Àpò",
  "pricing_summary.deposit": "Ìdógó",
  "pricing_summary.per_person": "fún ẹnìkọ̀ọ̀kan",
  "pricing_summary.discount": "Àdínkù Ìtọ́kasí",
  "pricing_summary.total_now": "Àpapọ̀ Tó Yẹ Báyìí",
  "pricing_summary.balance": "Ìyókù Owó",
  "success.title": "Ìpamọ́ Ti Jẹ́rìísí!",
  "success.confirmation": "Nọ́mbà Ìjẹ́rìísí",
  "success.details": "Àlàyé Ìpamọ́",
  "success.whatsapp_optin": "Gba ìmúdójúìwọ̀n nípasẹ̀ WhatsApp",
  "success.home": "Padà Sí Ilé",
  "driver.title": "Pánẹ́lì Awakọ̀",
  "driver.login": "Wọlé Awakọ̀",
  "driver.phone": "Nọ́mbà Fóònù",
  "driver.pin": "Kóòdù PIN",
  "driver.sign_in": "Wọlé",
  "driver.trips_today": "Àwọn Ìrìn Àjò Lónìí",
  "driver.upcoming": "Àwọn Ìrìn Àjò Tó Ń Bọ̀",
  "driver.passengers": "àwọn arìnrìn àjò",
  "driver.suitcases": "àwọn àpò",
  "driver.navigate": "Darí Sí Gbígbé",
  "driver.contact": "Kàn Sí Arìnrìn Àjò",
  "driver.complete": "Parí Ìrìn Àjò",
  "driver.logout": "Jáde",
  "driver.no_trips": "Kò sí ìrìn àjò tí a ṣètò",
  "common.loading": "Ń Ṣí...",
  "common.error": "Nǹkan kan ti ṣẹlẹ̀",
  "common.save": "Fi Pamọ́",
  "common.cancel": "Fagilé",
  "common.close": "Tì",
  "common.details": "Àlàyé",
  "common.status": "Ipò",
  "common.date": "Ọjọ́",
  "common.time": "Àkókò",
  "common.price": "Iye Owó",
  "common.passenger": "Arìnrìn Àjò",
  "common.passengers": "Àwọn Arìnrìn Àjò",
};
